<app-header
    style="width: 100%"
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchLanguageHandler($event)"
></app-header>

<section
    class="sme-new-app tw-pb-[45px] tw-bg-gradient-to-b tw-from-[#FFFBF8] tw-to-[30%] tw-to-[#F9F9F9]"
    (click)="closeMegaMenuCondition(); closeDropdown()"
>
    <div class="sme-container" #formContainer>
        <app-application-stepper [value]="value" [productName]="productName"></app-application-stepper>
        <mat-divider></mat-divider>
        <!--DESKTOP-->
        <div
            class="tw-hidden xl:tw-flex tw-flex-col tw-items-start tw-gap-[10px] md:tw-px-[75px]"
        >
            <div class="tw-flex tw-flex-col tw-gap-[10px]">
                <span
                    class="tw-font-bold tw-text-[#7B7575] tw-text-lg"
                    *ngIf="productName"
                >
                    {{ "NEW_APPLICATION.YOU_ARE_APPLYING_FOR" | translate }}
                </span>
                <div
                    class="tw-bg-[#E3E8EC] tw-w-auto tw-text-center tw-p-[16px] tw-rounded-[16px]"
                    *ngIf="productName"
                >
                    <span
                        class="md:tw-text-2xl tw-font-semibold tw-text-[#003A70]"
                    >
                        {{ productName }}
                    </span>
                </div>
            </div>
        </div>
        <!--DESKTOP-->

        <!--MOBILE-->
        <div
            class="tw-flex xl:tw-hidden tw-grid tw-items-center tw-grid-cols-1 xl:tw-grid-cols-[calc(100%_-_310px),300px] tw-gap-[10px] tw-pt-[40px] tw-pb-[20px] md:tw-pt-[10px] md:tw-pb-[10px] tw-mx-0 md:tw-mx-[80px] xl:tw-mx-0 tw-mt-3"
        >
            <div class="tw-flex tw-flex-col tw-gap-[12px]">
                <mat-card
                    class="cardCSS"
                    appearance="outlined"
                    *ngIf="productName"
                >
                    <mat-card-content>
                        <div class="tw-flex tw-flex-col tw-gap-[15px]">
                            <div
                                class="tw-font-[500] tw-text-[#6B6B6B] tw-text-[16px] tw-text-center"
                            >
                                {{
                                    "NEW_APPLICATION.YOU_ARE_APPLYING_FOR"
                                        | translate
                                }}
                            </div>
                            <div
                                class="tw-bg-[#E3E8EC] tw-p-[16px] tw-rounded-[16px] tw-text-center"
                            >
                                <span
                                    class="tw-text-[14px] tw-leading-[16.8px] tw-font-[700] tw-text-[#003A70]"
                                >
                                    {{ productName }}
                                </span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <ngx-slick-carousel
                    class="carousel"
                    #slickModal="slick-carousel"
                    [config]="slideConfig"
                    (afterChange)="afterChange($event)"
                    (beforeChange)="beforeChange($event)"
                >
                    <div ngxSlickItem *ngFor="let i of rightSide; let index = index">
                        <div
                            class="tw-relative tw-w-full tw-h-auto tw-overflow-hidden tw-rounded-lg md:tw-rounded-2xl"
                        >
                            <mat-card
                                class="cardCSS"
                                appearance="outlined"
                            >
                                <mat-card-content>
                                    <div
                                        class="tw-flex tw-flex-col tw-gap-[10px] mat-divider-carousel"
                                    >
                                        <div
                                            class="tw-flex tw-flex-row tw-gap-[14px] tw-mt-[1%] tw-mb-[2%]"
                                        >
                                            <img
                                                *ngIf="index == 0"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/preliminary.png"
                                                alt="preliminary"
                                            />
                                            <img
                                                *ngIf="index == 1"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/expand_circle_right.png"
                                                alt="expand_circle_right"
                                            />
                                            <img
                                                *ngIf="index == 2"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/done.png"
                                                alt="done"
                                            />
                                            <div
                                                class="tw-font-semibold tw-leadng-[21.6px] tw-text-[18px] tw-m-auto"
                                            >
                                                {{
                                                    i.title | translate
                                                }}
                                            </div>
                                        </div>
                                        <mat-divider
                                            class="small"
                                        ></mat-divider>
                                        <div
                                            class="tw-font-medium tw-leading-[24px] tw-text-[16px] tw-mb-[14px] tw-my-[2%]"
                                        >
                                            {{
                                                i.subtitle | translate
                                            }}
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
        <!--MOBILE-->
        <div
            [ngClass]="
                productName
                    ? 'tw-pt-0 md:tw-pt-[3%] xl:tw-pt-[5%]'
                    : ' md:tw-pt-[3%] xl:tw-pt-0'
            "
            class="tw-grid tw-grid-cols-1"
        >
            <div class="md:tw-px-[75px]">
                <div
                    class="tw-hidden md:tw-flex tw-justify-between md:tw-justify-start tw-items-center tw-mt-[40px] md:tw-mt-0"
                >
                    <h5 class="sme-new-app">
                        {{
                            "NEW_APPLICATION.DOCUMENT_UPLOAD.TITLE" | translate
                        }}
                    </h5>
                </div>
                <div
                    class="tw-mt-[20px] md:tw-mt-0 tw-text-[#8D8D8D] tw-text-center md:tw-text-left"
                    *ngIf="!uploadMandatory"
                >
                    {{ "NEW_APPLICATION.DOCUMENT_UPLOAD.SUBTITLE" | translate }}
                </div>
                <div
                    class="tw-mt-[20px] md:tw-mt-0 tw-text-[#8D8D8D] tw-text-center md:tw-text-left"
                    *ngIf="uploadMandatory"
                >
                    {{ "NEW_APPLICATION.DOCUMENT_UPLOAD.SUBTITLE_MANDATORY" | translate }}
                </div>
                <div
                    class="tw-py-5 tw-px-8 tw-bg-[#95d1f354] tw-rounded-xl tw-mt-6 tw-flex tw-flex-col tw-gap-6"
                >
                    <div
                        class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between"
                        [ngClass]="{ 'mandatory-doc': bankStatementMandatory && !isBankStatementUploaded }"
                    >
                        <div class="tw-flex tw-flex-col tw-gap-1">
                            <div
                                class="tw-text-[#003A70] tw-font-bold tw-text-lg"
                            >
                                {{
                                    "NEW_APPLICATION.DOCUMENT_UPLOAD.BANK_STATEMENT"
                                        | translate
                                }}
                                <span
                                    *ngIf="bankStatementMandatory"
                                    class="tw-text-[#FF2400]"
                                    >*</span
                                >
                            </div>
                            <div class="tw-text-[#5E758C] tw-font-bold">
                                {{
                                    "NEW_APPLICATION.DOCUMENT_UPLOAD.DOCS_SUBTITLE"
                                        | translate
                                }}
                            </div>
                        </div>
                        <input
                            #bankStatementUpload
                            accept=".png, .jpeg, .pdf, .jpg"
                            (change)="onUploadSelectedFile($event, BANK, '1')"
                            type="file"
                            class="tw-hidden"
                        />
                        <button
                            mat-raised-button
                            class="tw-rounded-[16px] md:tw-rounded-3xl tw-bg-[#003A70] tw-p-[16px_24px] md:tw-p-[8px_24px] tw-text-white tw-font-bold tw-w-full md:tw-w-[146px] tw-mt-[15px] md:tw-mt-0"
                            (click)="bankStatementUpload.click()"
                        >
                            {{
                                "NEW_APPLICATION.DOCUMENT_UPLOAD.CHOOSE_A_FILE"
                                    | translate
                            }}
                        </button>
                    </div>
                    <div class="tw-flex tw-flex-col">
                        <div
                            *ngFor="let list of bankStatmentResponse"
                            class="tw-flex tw-items-center tw-justify-between tw-py-4 tw-border-b-[1px] tw-border-[#6d7a8741] tw-gap-2"
                        >
                            <div class="tw-flex tw-gap-4 tw-items-center">
                                <div
                                    class="tw-bg-[#4B6EEC] tw-min-w-[24px] tw-min-h-[24px] tw-rounded-full tw-flex tw-justify-center tw-items-center"
                                >
                                    <img
                                        src="/assets/images/check-icon.png"
                                        alt="Check Icon"
                                        class="tw-w-[16px] tw-h-[16px]"
                                    />
                                </div>
                                <div
                                    class="tw-font-semibold tw-text-[#003A70]"
                                    *ngIf="list?.status == ACTIVE"
                                >
                                    <span
                                        class="hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(list?.docsId)
                                        "
                                    >
                                        {{ list?.originalfilename }}
                                    </span>
                                </div>
                            </div>
                            <div
                                (click)="
                                    deleteDocument(list?.docsId, list?.caseId, '1')
                                "
                                class="tw-cursor-pointer tw-bg-[#4b6eec46] tw-rounded-full tw-flex tw-p-1"
                            >
                                <mat-icon class="tw-w-3 tw-text-[#003A70]">
                                    delete_outline
                                </mat-icon>
                            </div>
                        </div>
                    </div>
                    <div class="tw-text-[#5E758C]">
                        {{
                            "NEW_APPLICATION.DOCUMENT_UPLOAD.BANK_INFO"
                                | translate
                        }}
                    </div>
                </div>

                <div
                    class="tw-py-5 tw-px-8 tw-bg-[#95d1f354] tw-rounded-xl tw-mt-6 tw-flex tw-flex-col tw-gap-6"
                >
                    <div
                        class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between"
                        [ngClass]="{ 'mandatory-doc': ssmDocMandatory && !isSSMDocUploaded }"
                    >
                        <div class="tw-flex tw-flex-col tw-gap-1">
                            <div
                                class="tw-text-[#003A70] tw-font-bold tw-text-lg"
                            >
                                {{
                                    "NEW_APPLICATION.DOCUMENT_UPLOAD.SSM_CERITIFICATE"
                                        | translate
                                }}
                                <span
                                    *ngIf="ssmDocMandatory"
                                    class="tw-text-[#FF2400]"
                                    >*</span
                                >
                            </div>
                            <div class="tw-text-[#5E758C] tw-font-bold">
                                {{
                                    "NEW_APPLICATION.DOCUMENT_UPLOAD.DOCS_SUBTITLE"
                                        | translate
                                }}
                            </div>
                        </div>
                        <input
                            #ssmUpload
                            accept=".png, .jpeg, .pdf, .jpg"
                            (change)="onUploadSelectedFile($event, SSM, '2')"
                            type="file"
                            class="tw-hidden"
                        />
                        <button
                            mat-raised-button
                            class="tw-rounded-[16px] md:tw-rounded-3xl tw-bg-[#003A70] tw-p-[16px_24px] md:tw-p-[8px_24px] tw-text-white tw-font-bold tw-w-full md:tw-w-[146px] tw-mt-[15px] md:tw-mt-0"
                            (click)="ssmUpload.click()"
                        >
                            {{
                                "NEW_APPLICATION.DOCUMENT_UPLOAD.CHOOSE_A_FILE"
                                    | translate
                            }}
                        </button>
                    </div>
                    <div class="tw-flex tw-flex-col">
                        <div
                            *ngFor="let list of ssmResponse"
                            class="tw-flex tw-items-center tw-justify-between tw-py-4 tw-border-b-[1px] tw-border-[#6d7a8741] tw-gap-2"
                        >
                            <div class="tw-flex tw-gap-4 tw-items-center">
                                <div
                                    class="tw-bg-[#4B6EEC] tw-min-w-[24px] tw-min-h-[24px] tw-rounded-full tw-flex tw-justify-center tw-items-center"
                                >
                                    <img
                                        src="/assets/images/check-icon.png"
                                        alt="Check Icon"
                                        class="tw-w-[16px] tw-h-[16px]"
                                    />
                                </div>
                                <div
                                    class="tw-font-semibold tw-text-[#003A70]"
                                    *ngIf="list?.status == ACTIVE"
                                >
                                    <span
                                        class="hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(list?.docsId)
                                        "
                                    >
                                        {{ list?.originalfilename }}
                                    </span>
                                </div>
                            </div>
                            <div
                                (click)="
                                    deleteDocument(list?.docsId, list?.caseId, '2')
                                "
                                class="tw-cursor-pointer tw-bg-[#4b6eec46] tw-rounded-full tw-flex tw-p-1"
                            >
                                <mat-icon class="tw-w-3 tw-text-[#003A70]">
                                    delete_outline
                                </mat-icon>
                            </div>
                        </div>
                    </div>
                    <div class="tw-text-[#5E758C]">
                        {{
                            "NEW_APPLICATION.DOCUMENT_UPLOAD.SSM_INFO"
                                | translate
                        }}
                    </div>
                </div>

                <div
                    class="tw-py-5 tw-px-8 tw-bg-[#95d1f354] tw-rounded-xl tw-mt-6 tw-flex tw-flex-col tw-gap-6"
                >
                    <div
                        class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between"
                        [ngClass]="{ 'mandatory-doc': proofOfAddressMandatory && !isproofOfAddressUploaded }"
                    >
                        <div class="tw-flex tw-flex-col tw-gap-1">
                            <div
                                class="tw-text-[#003A70] tw-font-bold tw-text-lg"
                            >
                                {{
                                    "NEW_APPLICATION.DOCUMENT_UPLOAD.PROOF_OF_ADDRESS"
                                        | translate
                                }}
                                <span
                                    *ngIf="proofOfAddressMandatory"
                                    class="tw-text-[#FF2400]"
                                    >*</span
                                >
                            </div>
                            <div class="tw-text-[#5E758C] tw-font-bold">
                                {{
                                    "NEW_APPLICATION.DOCUMENT_UPLOAD.DOCS_SUBTITLE"
                                        | translate
                                }}
                            </div>
                        </div>
                        <input
                            #poaUpload
                            accept=".png, .jpeg, .pdf, .jpg"
                            (change)="onUploadSelectedFile($event, POA, '3')"
                            type="file"
                            class="tw-hidden"
                        />
                        <button
                            mat-raised-button
                            class="tw-rounded-[16px] md:tw-rounded-3xl tw-bg-[#003A70] tw-p-[16px_24px] md:tw-p-[8px_24px] tw-text-white tw-font-bold tw-w-full md:tw-w-[146px] tw-mt-[15px] md:tw-mt-0"
                            (click)="poaUpload.click()"
                        >
                            {{
                                "NEW_APPLICATION.DOCUMENT_UPLOAD.CHOOSE_A_FILE"
                                    | translate
                            }}
                        </button>
                    </div>
                    <div class="tw-flex tw-flex-col">
                        <div
                            *ngFor="let list of proofOfAddressResponse"
                            class="tw-flex tw-items-center tw-justify-between tw-py-4 tw-border-b-[1px] tw-border-[#6d7a8741] tw-gap-2"
                        >
                            <div class="tw-flex tw-gap-4 tw-items-center">
                                <div
                                    class="tw-bg-[#4B6EEC] tw-min-w-[24px] tw-min-h-[24px] tw-rounded-full tw-flex tw-justify-center tw-items-center"
                                >
                                    <img
                                        src="/assets/images/check-icon.png"
                                        alt="Check Icon"
                                        class="tw-w-[16px] tw-h-[16px]"
                                    />
                                </div>
                                <div
                                    class="tw-font-semibold tw-text-[#003A70]"
                                    *ngIf="list?.status == ACTIVE"
                                >
                                    <span
                                        class="hover:tw-underline tw-cursor-pointer"
                                        (click)="
                                            viewORdownloadDocs(list?.docsId)
                                        "
                                    >
                                        {{ list?.originalfilename }}
                                    </span>
                                </div>
                            </div>
                            <div
                                (click)="
                                    deleteDocument(list?.docsId, list?.caseId, '3')
                                "
                                class="tw-cursor-pointer tw-bg-[#4b6eec46] tw-rounded-full tw-flex tw-p-1"
                            >
                                <mat-icon class="tw-w-3 tw-text-[#003A70]">
                                    delete_outline
                                </mat-icon>
                            </div>
                        </div>
                    </div>
                    <div class="tw-text-[#5E758C]">
                        {{
                            "NEW_APPLICATION.DOCUMENT_UPLOAD.POA_INFO"
                                | translate
                        }}
                    </div>
                </div>

                <div
                    class="tw-flex tw-gap-3 tw-items-start tw-mt-5 tw-mb-[24px]"
                >
                    <input
                        [ngClass]="{ 'mandatory-doc': submitted && checkboxError }"
                        [attr.ga-event-id]="prodCode ? prodCode + '_term&conditions_tick_button_upload_document_click' : 'term&conditions_tick_button_upload_document_click'"
                        ga-event-category="Upload Document Button"
                        [attr.ga-event-label]="prodCode ? prodCode + ' Term & Conditions Tick Button Click' : 'Term & Conditions Tick Button Click'"
                        ga-track="track"
                        class="tw-w-[20px] tw-h-[20px] tw-cursor-pointer"
                        type="checkbox"
                        [(ngModel)]="isChecked"
                        (click)="checkChecked()"
                        [checked]="isChecked"
                    />
                    <div class="tw-text-[#8D8D8D]">
                        {{
                            "NEW_APPLICATION.DOCUMENT_UPLOAD.STATEMENT_1"
                                | translate
                        }}
                        <span
                            class="tw-font-bold tw-text-[#000000] hover:tw-underline"
                        >
                            <a
                                href="/assets/documents/Terms For Documentation Uploading.pdf"
                                alt="Image description"
                                target="_blank"
                            >
                                {{
                                    "NEW_APPLICATION.DOCUMENT_UPLOAD.STATEMENT_2"
                                        | translate
                                }}
                            </a>
                        </span>
                        {{
                            "NEW_APPLICATION.DOCUMENT_UPLOAD.STATEMENT_3"
                                | translate
                        }}{{
                            "NEW_APPLICATION.DOCUMENT_UPLOAD.STATEMENT_4"
                                | translate
                        }}{{
                            "NEW_APPLICATION.DOCUMENT_UPLOAD.STATEMENT_5"
                                | translate
                        }}
                        <span
                            class="tw-font-bold tw-text-[#000000] hover:tw-underline"
                            *ngIf="selectedLanguage == 'en'"
                        >
                            <a
                                href="/assets/documents/Privacy & Security Policies.pdf"
                                alt="Image description"
                                target="_blank"
                            >
                                {{
                                    "NEW_APPLICATION.DOCUMENT_UPLOAD.STATEMENT_6"
                                        | translate
                                }}
                            </a>
                        </span>
                        <span
                            class="tw-font-bold tw-text-[#000000] hover:tw-underline"
                            *ngIf="selectedLanguage == 'bm'"
                        >
                            <a
                                href="/assets/documents/Polisi Privasi(BM).pdf"
                                alt="Image description"
                                target="_blank"
                            >
                                {{
                                    "NEW_APPLICATION.DOCUMENT_UPLOAD.STATEMENT_6"
                                        | translate
                                }}
                            </a>
                        </span>
                    </div>
                </div>
                <div
                    class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                    *ngIf="submitted && checkboxError"
                >
                    <mat-icon class="error-icon !tw-overflow-visible"
                        >error_outline</mat-icon
                    >
                    <span class="tw-pt-3 tw-pb-3">
                        {{
                            "NEW_APPLICATION.ACCEPT_TERMS_CONDITIONS"
                                | translate
                        }}</span
                    >
                </div>

                <mat-divider
                    class="dividerDirector"
                    style="margin-bottom: 0 !important"
                ></mat-divider>
                <div
                    class="tw-hidden md:tw-flex tw-flex-wrap md:tw-flex-row md:tw-justify-end tw-gap-[10px] tw-items-center md:tw-rounded-[80px] tw-py-4 tw-px-0 md:tw-px-[15px] lg:tw-px-[27px]"
                >
                    <div
                        class="tw-order-3 md:tw-order-2 tw-flex-[0_0_calc(50%_-_5px)] md:tw-flex-[0_0_180px]"
                    >
                        <button
                            [attr.ga-event-id]="prodCode ? prodCode + '_save_as_upload_document_click' : 'save_as_upload_document_click'"
                            ga-event-category="Upload Document Button"
                            [attr.ga-event-label]="prodCode ? prodCode + ' Save As Draft Button Click' : 'Save As Draft Button Click'"
                            ga-track="track"
                            class="tw-text-caption-gray md:tw-max-w-[175px] tw-w-full tw-text-center"
                            type="submit"
                            name="draft"
                            (click)="saveApplicationAsDraft()"
                        >
                            {{ "SAVE_AS_DRAFT" | translate }}
                        </button>
                    </div>
                    <div
                        class="tw-order-1 md:tw-order-last tw-flex-[0_0_calc(50%_-_5px)] md:tw-flex-[0_0_180px] tw-mb-[10px] md:tw-mb-0"
                    >
                        <button
                            [attr.ga-event-id]="prodCode ? prodCode + '_next_step_application_button_finp_click' : 'next_step_application_button_finp_click'"
                            ga-event-category="Upload Document Button"
                            [attr.ga-event-label]="prodCode ? prodCode + ' Next Step Application Button Click' : 'Next Step Application Button Click'"
                            ga-track="track"
                            class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                            [ngClass]="
                                !disableSubmitBtn
                                ? 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                                : 'tw-bg-slate-300'
                            "
                            type="submit"
                            name="next"
                            [disabled]="disableSubmitBtn"
                            (click)="submitApplication()"
                        >
                            {{ "COMMON.SUBMIT" | translate }}
                        </button>
                    </div>
                </div>
                <div
                    class="tw-flex md:tw-hidden tw-flex-col tw-gap-[10px] tw-items-center tw-py-4 tw-px-0"
                >
                    <button
                        [attr.ga-event-id]="prodCode ? prodCode + '_next_step_application_button_finp_click' : 'next_step_application_button_finp_click'"
                        ga-event-category="Upload Document Button"
                        [attr.ga-event-label]="prodCode ? prodCode + ' Next Step Application Button Click' : 'Next Step Application Button Click'"
                        ga-track="track"
                        class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                        [ngClass]="
                            !disableSubmitBtn
                            ? 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                            : 'tw-bg-slate-300'
                        "
                        type="submit"
                        name="next"
                        [disabled]="disableSubmitBtn"
                        (click)="submitApplication()"
                    >
                        {{ "COMMON.SUBMIT" | translate }}
                    </button>
                    <button
                        [attr.ga-event-id]="prodCode ? prodCode + '_save_as_upload_document_click' : 'save_as_upload_document_click'"
                        ga-event-category="Upload Document Button"
                        [attr.ga-event-label]="prodCode ? prodCode + ' Save As Draft Button Click' : 'Save As Draft Button Click'"
                        ga-track="track"
                        class="tw-text-caption-gray md:tw-max-w-[175px] tw-w-full tw-text-center"
                        type="submit"
                        name="draft"
                        (click)="saveApplicationAsDraft()"
                    >
                        {{ "SAVE_AS_DRAFT" | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
<app-footer (click)="closeMegaMenuCondition()"></app-footer>
<app-loader [showLoader]="!apiResponse"></app-loader>
